module.exports = __webpack_public_path__ + "images/emoji/stuck_out_tongue.3b1558396efb199b2e56.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/stuck_out_tongue.png
// module id = OTk3
// module chunks = 2